// Where a NoVA citation opens on this instance. Citations are
// { ref, docId, title } from the knowledge collection; every knowledge doc
// a seat may read is readable on the Brain page, so one route serves all:
//   /brain?view=knowledge&page=<docId>
// The Brain API enforces the seat (a page above it answers 404), so the
// link never widens access.
export function citationHref(c) {
  const id = String(c?.docId || '');
  return id ? `/brain?view=knowledge&page=${encodeURIComponent(id)}` : null;
}

export function citationKind(c) {
  const id = String(c?.docId || '');
  if (id.startsWith('layer-brain-')) return 'app';
  if (id.startsWith('brain-')) return 'kit';
  if (id.startsWith('app-')) return 'design';
  return 'doc';
}
